import { NavLink } from "react-router-dom";
import { Mail, BookOpen } from "lucide-react";

const tabs = [
  { to: "/admin/enquiries", label: "Enquiries", icon: Mail, testId: "tab-enquiries" },
  { to: "/admin/leads", label: "Guide Downloads", icon: BookOpen, testId: "tab-leads" },
];

export const AdminTabs = () => (
  <div
    className="flex gap-2 mb-6 border-b border-[color:var(--nr-line)]"
    data-testid="admin-tabs"
  >
    {tabs.map((t) => {
      const Icon = t.icon;
      return (
        <NavLink
          key={t.to}
          to={t.to}
          data-testid={t.testId}
          className={({ isActive }) =>
            `inline-flex items-center gap-2 px-5 py-3 text-xs uppercase tracking-[0.2em] font-semibold border-b-2 -mb-px transition-colors ${
              isActive
                ? "border-[color:var(--nr-accent)] text-[color:var(--nr-ink)]"
                : "border-transparent text-[color:var(--nr-ink-soft)] hover:text-[color:var(--nr-ink)]"
            }`
          }
        >
          <Icon size={14} />
          {t.label}
        </NavLink>
      );
    })}
  </div>
);
